import { SmartTable } from '../../../../components/smart-table/smart-table.model';
import { appProtocolDisplayName } from '../../../../../util/sp-util';

export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.st = new SmartTable();
        this.applications.map(application => this.setDisplayNames(application));
    }

    setDisplayNames(application) {
        application.typeDisplayName = this.typeDisplayName(application);
        application.protocolDisplayName = appProtocolDisplayName(application);
    }

    typeDisplayName(app) {
        let displayName = app.publicService ? app.publicService.serviceName + ' - ' + app.applicationTypeDisplayName : app.applicationTypeDisplayName;
        return displayName;
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/added-applications-list/added-applications-list.controller.js